import { ArrowLeftIcon } from "lucide-react";
import { Link, Navigate, useParams } from "react-router-dom";

import { LoadingScreen } from "@/components/loading-screen";
import { Button } from "@/components/ui/button";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { useGetSession } from "@/features/session/api/get-session";
import { SessionForm } from "@/features/session/components/session.form";

export default function EditSessionPage() {
  const { sessionId } = useParams();
  const {
    data: session,
    isLoading,
    isSuccess,
    isError,
  } = useGetSession(sessionId ?? "");

  if (isLoading) {
    return (
      <div>
        <div className="mb-6">
          <Button variant="link" asChild>
            <Link to="/sessions">
              <ArrowLeftIcon className="mr-2 h-4 w-4" /> Back to session
            </Link>
          </Button>
        </div>
        <OnboardingHeader title="Edit Session" className="mb-6" />

        <LoadingScreen />
      </div>
    );
  }

  if (isError || !isSuccess) {
    return <Navigate to="/sessions" />;
  }

  return (
    <div>
      <div className="mb-6">
        <Button variant="link" asChild>
          <Link to="/sessions">
            <ArrowLeftIcon className="mr-2 h-4 w-4" /> Back to session
          </Link>
        </Button>
      </div>
      <OnboardingHeader title="Edit Session" className="mb-6" />
      <SessionForm initialValues={session} />
    </div>
  );
}
